import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1beed56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrap" }

import { Button } from 'vant'
import { withDefaults } from 'vue'
import { useThreeLiabilityFunction } from '@/compositions/insurance/index'
import { WaitReceiveThreeLiabilityUavItem } from '@/types/insurance'
import DeviceInfoItem from './device-info-item.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'unrecive-insurance-list',
  props: {
    list: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { list: WaitReceiveThreeLiabilityUavItem[] };


const { getReceiveThreeLiabilityUrl } = useThreeLiabilityFunction()
function getDeviceInfo(item: WaitReceiveThreeLiabilityUavItem) {
  return {
    ...item,
    sn: item.serial_number,
  }
}
// 跳转到领取界面
async function toReceive(item: WaitReceiveThreeLiabilityUavItem) {
  const url = await getReceiveThreeLiabilityUrl({
    sn: item.serial_number,
    name: item.name,
    deviceName: `${item.name}（${item.serial_number}）`,
  })
  // 去往领取

  window.location.href = url
  // window.open(url)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        key: item.serial_number
      }, [
        _createVNode(DeviceInfoItem, {
          data: getDeviceInfo(item)
        }, null, 8, ["data"]),
        _createVNode(_unref(Button), {
          round: "",
          class: "xa-vant-button",
          onClick: ($event: any) => (toReceive(item))
        }, {
          default: _withCtx(() => [
            _createTextVNode("领取")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128))
  ]))
}
}

})